// Package Imports

// Project Imports
import resourceName from 'core/common/resourceName';
import ResourceItem from 'interfaces/resource';
import PrivateRouteConst from 'core/common/privateRouteConstant';

const icon = (
  <svg
    viewBox="64 64 896 896"
    focusable="false"
    data-icon="cloud-download"
    width="24"
    height="24"
    fill="currentColor"
    aria-hidden="true"
  >
    <path d="M624 706.3h-74.1V464c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v242.3H400c-6.7 0-10.4 7.7-6.3 12.9l112 141.7a8 8 0 0012.6 0l112-141.7c4.1-5.2.4-12.9-6.3-12.9z" />

    <path d="M811.4 366.7C765.6 245.9 648.9 160 512.2 160S258.8 245.8 213 366.6C127.3 389.1 64 467.2 64 560c0 110.5 89.5 200 199.9 200H304c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8h-40.1c-33.7 0-65.4-13.4-89-37.7-23.5-24.2-36-56.8-34.9-90.6.9-26.4 9.9-51.2 26.2-72.1 16.7-21.3 40.1-36.8 66.1-43.7l37.9-9.9 13.9-36.6c8.6-22.8 20.6-44.1 35.7-63.4a245.6 245.6 0 0152.4-49.9c41.1-28.9 89.5-44.2 140-44.2s98.9 15.3 140 44.2c19.9 14 37.5 30.8 52.4 49.9 15.1 19.3 27.1 40.7 35.7 63.4l13.8 36.5 37.8 10C846.1 454.5 884 503.8 884 560c0 33.1-12.9 64.3-36.3 87.7a123.07 123.07 0 01-87.6 36.3H720c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h40.1C870.5 760 960 670.5 960 560c0-92.7-63.1-170.7-148.6-193.3z" />
  </svg>
);

const BulkRuleDownloadResource: ResourceItem = {
  name: resourceName.bulkRuleDownload,
  identifier: PrivateRouteConst.RULE_BULK_DOWNLOAD,
  list: `${resourceName.bulkRuleDownload}`,
  create: `${resourceName.bulkRuleDownload}/create`,
  edit: `${resourceName.bulkRuleDownload}/edit/:id`,
  show: `${resourceName.bulkRuleDownload}/show/:id`,
  options: { label: 'Bulk Rule Download', icon },
  meta: {
    label: 'Bulk Rule',
    icon,
    parent: resourceName.bulkRule,
  },
};

export default BulkRuleDownloadResource;
